import React, { Component } from 'react';
import cn from 'classnames';
import { Field } from 'redux-form';
import styles from './Profile.scss';

import iconVk from 'assets/images/icons/social-vk.svg';
import iconOk from 'assets/images/icons/social-ok.svg';
import iconFb from 'assets/images/icons/social-fb.svg';
import iconInst from 'assets/images/icons/social-inst.svg';
import iconYoutube from 'assets/images/icons/social-youtube.svg';
import { withTranslation } from 'react-i18next';
import i18n from '../../i18n';

const SocialInput = ({ input, placeholder, id }) => (
  <input
    className={cn(styles.Input, styles.SocialInput, { [styles.Touched]: !!input.value })}
    id={id}
    placeholder={placeholder}
    {...input}
  />
);

const items = [
  {
    name: 'vk',
    icon: iconVk,
    label: i18n.t('components.profile.profileForm.vk')
  },
  {
    name: 'ok',
    icon: iconOk,
    label: i18n.t('components.profile.profileForm.ok')
  },
  {
    name: 'facebok',
    icon: iconFb,
    label: 'Facebook'
  },
  {
    name: 'instagram',
    icon: iconInst,
    label: 'Instagram'
  },
  {
    name: 'youtube',
    icon: iconYoutube,
    label: 'YouTube'
  }
];

class Social extends Component {

  render() {
    const { t } = this.props;
    return (
      <div className={styles.Social}>
        {
        items.map(
          ({ name, icon, label }) =>
            <div className={styles.SocialInputWrap} key={name}>
              <Field component={SocialInput} name={name} placeholder={t('components.profile.profileForm.profileLink')} />
              <label className={styles.SocialLabel}>
                <img src={icon} alt="" />
                { label }
              </label>
            </div>
        )
      }
      </div>
    );
  }
}

export default withTranslation()(Social);



// WEBPACK FOOTER //
// ./src/components/Profile/Social.js